export const LANGS = ["ar", "en"];
export const DEFAULT_LANG = "ar";
export const STORAGE_KEY = "alabrad_lang";

export const isLang = (value) => LANGS.includes(value);

/** First path segment, if it is a supported language code. */
export const langFromPath = (pathname) => {
  const seg = pathname.split("/")[1];
  return isLang(seg) ? seg : null;
};

/** Path with any language prefix removed, always starting with "/". */
export const stripLang = (pathname) => {
  const seg = pathname.split("/")[1];
  if (!isLang(seg)) return pathname || "/";
  const rest = pathname.slice(seg.length + 1);
  return rest || "/";
};

/** Prefix a language-agnostic path with a language code. */
export const withLang = (lang, path = "/") => {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return clean === "/" ? `/${lang}` : `/${lang}${clean}`;
};

/**
 * Which language a first-time visitor should land in.
 *
 * An explicit past choice wins over browser settings. Otherwise we read
 * navigator.languages and fall back to Arabic, since the audience is Iraqi.
 */
export const detectLang = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isLang(stored)) return stored;
  } catch {
    // localStorage can throw in private mode — fall through to detection.
  }

  const candidates =
    typeof navigator !== "undefined"
      ? navigator.languages || [navigator.language]
      : [];

  for (const tag of candidates) {
    if (!tag) continue;
    const base = tag.toLowerCase().split("-")[0];
    if (base === "ar") return "ar";
    if (base === "en") return "en";
  }

  return DEFAULT_LANG;
};

export const rememberLang = (lang) => {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // Non-fatal: the URL still carries the language.
  }
};
